import { WifiOff } from 'lucide-react'
import { useT } from './i18n.ts'
import { Spinner } from './kit/feedback.tsx'

export type ConnState = 'Dropped' | 'Connecting' | 'Attached' | 'catching_up'

/**
 * 연결 상태 띠.
 *
 * ## '붙음' 일 때는 아무것도 안 그린다
 * 정상을 알리는 UI 는 소음이다. **비정상일 때만** 나타나야 사람이 알아챈다.
 *
 * '따라잡는중' 을 따로 두는 이유는, 붙긴 했는데 아직 과거를 메우는 중이라
 * 타임라인이 비어 보일 수 있기 때문이다. 이걸 안 알려 주면 "메시지가 사라졌다" 로 읽힌다.
 */
export function ConnIndicator({ status }: { status: ConnState }) {
  const t = useT()
  if (status === 'Attached') return null

  const text = {
    Dropped: t('연결이 끊겼어요. 다시 연결하는 중…'),
    Connecting: t('연결하는 중…'),
    catching_up: t('놓친 메시지를 가져오는 중…'),
  }[status]

  return (
    <div className={`ConnIndicator ${status}`} role="status" aria-live="polite">
      {status === 'Dropped' ? <WifiOff size={14} aria-hidden /> : <Spinner />}
      {text}
    </div>
  )
}
